module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('em', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_frw_r1.htm"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_itr_r1.htm"
    }
  }, [_c('em', [_vm._v("Introduction")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c01_r1.htm"
    }
  }, [_vm._v("Schoolhouse Rocks")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c02_r1.htm"
    }
  }, [_vm._v("Shoot Down")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c03_r1.htm"
    }
  }, [_vm._v("Not Ready to Be an Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c04_r1.htm"
    }
  }, [_vm._v("Call Sign: “Krusty”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c05_r1.htm"
    }
  }, [_vm._v("The Little Bird that Could")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c06_r1.htm"
    }
  }, [_vm._v("Little Dee with a Big Gun")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c07_r1.htm"
    }
  }, [_vm._v("Who Wants to Be Average?")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c08_r1.htm"
    }
  }, [_vm._v("Taking Command of the Herk")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c09_r1.htm"
    }
  }, [_vm._v("Live from Iraq")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c10_r1.htm"
    }
  }, [_vm._v("The Healers of the Guardians of Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_c11_r1.htm"
    }
  }, [_vm._v("Roll with It")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_epi_r1.htm"
    }
  }, [_c('em', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_aft_r1.htm"
    }
  }, [_c('em', [_vm._v("Afterword")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_ack_r1.htm"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780811740111_epub_ind_r1.htm"
    }
  }, [_c('em', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-245d571c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780811740111_epub_toc_r1.vue
// module id = 66
// module chunks = 0